/**
 * Whether venues are chosen through the Region → City → Gender → Club funnel
 * (LocationFunnelPicker) instead of a flat list. Only school networks have the
 * metadata, and only past a handful of venues is a flat list hard to scan.
 * Shared by /book and the venue picker popup so both surfaces agree.
 */
export function usesSchoolsLocationFunnel(
  businessType: string | null | undefined,
  locationCount: number,
): boolean {
  return businessType === 'schools' && locationCount > 5;
}
